import mermaid from 'mermaid';

let initialized = false;

export async function runMermaid() {
  if (!initialized) {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'default',
      securityLevel: 'loose', // allow clicks, etc.
      fontFamily: 'inherit',
    });
    initialized = true;
  }

  // Find all code blocks that either have lang="mermaid" OR whose content looks like a mermaid diagram
  const isMermaidContent = (text) => {
    const content = text.trim();
    return content.startsWith('graph') || 
           content.startsWith('flowchart') || 
           content.startsWith('sequenceDiagram') || 
           content.startsWith('gantt') ||
           content.startsWith('classDiagram') ||
           content.startsWith('stateDiagram') ||
           content.startsWith('pie');
  };

  const blocksToProcess = [];
  const isInsideNativeDocumentation = (block) => (
    block.closest('[data-native-documentation-diagram]') ||
    block.closest('[data-documentation-canvas-diagram]') ||
    block.closest('[data-documentation-article]')
  );

  // Strategy 1: Look for explicit lang="mermaid"
  document.querySelectorAll('pre[lang="mermaid"]').forEach((block) => {
    if (!isInsideNativeDocumentation(block)) blocksToProcess.push(block);
  });

  // Strategy 2: Look for <code> blocks containing mermaid keywords
  document.querySelectorAll('pre code').forEach((block) => {
    if (isMermaidContent(block.textContent) && !isInsideNativeDocumentation(block) && !blocksToProcess.includes(block)) {
      blocksToProcess.push(block);
    }
  });

  for (let i = 0; i < blocksToProcess.length; i++) {
    const block = blocksToProcess[i];
    
    // If already processed, skip
    if (block.closest('.mermaid-processed')) continue;

    const code = block.textContent;
    const parentPre = block.tagName.toLowerCase() === 'PRE' ? block : block.closest('pre');
    if (!parentPre) continue;
    
    // Mark as processed immediately so it's not processed twice
    parentPre.classList.add('mermaid-processed');

    try {
      // Generate a unique ID for the render container
      const id = `mermaid-graph-${Math.random().toString(36).substr(2, 9)}`;
      
      // Use the async render API to bypass the querySelector mutation issues
      const { svg } = await mermaid.render(id, code);
      
      const div = document.createElement('div');
      div.className = 'mermaid-processed flex justify-center my-8';
      div.innerHTML = svg;
      
      parentPre.parentNode.replaceChild(div, parentPre);
    } catch (e) {
      console.error("Mermaid parsing error", e);
      // On error, let's remove the processed class so it can be retried if needed
      parentPre.classList.remove('mermaid-processed');
    }
  }
}
